import Web3 from "web3"
import web3Config, { INFI_CONTRACT, USDT_CONTRACT, USDT_DECIMAL, POLYGON_RPC } from "./web3Config";
import Erc20Abi from "./Erc20Abi.json"
//import StakingAbi from "./StakingAbi.json";
import StakingAbi from "./newstakeabi.json"


////New Runing Code
const validateProvider = async (walletProvider) => {
  walletProvider = await walletProvider;
  if (!walletProvider) {
    return {
      status: false,
      message: `Please connect your web3 wallet`,
    }
  }
  const web3 = new Web3(walletProvider)
  // let accounts = await walletProvider.request({   /* New */
  //   method: "eth_requestAccounts",                 /* New */
  // })
  // const currentProvider = await web3.currentProvider;

  const maticNetwork = {
    chainId: web3Config.CHAIN,
    chainName: web3Config.NETWORK,
    nativeCurrency: {
      name: web3Config.NETWORK,
      symbol: web3Config.SYMBOL,
      decimals: 18,
    },
    rpcUrls: web3Config.POLYGON_RPC,
    blockExplorerUrls: web3Config.Explore
  }

  const chainId = await web3.currentProvider.chainId;
  //console.log('xxxx',web3.utils.toHex(web3Config.CHAIN))
  if (chainId != web3.utils.toHex(web3Config.CHAIN)){
    try{    
      await walletProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: web3.utils.toHex(web3Config.CHAIN) }],
    });
   } catch(switchError) {
    if (switchError.code === 4902 || switchError.code === 32603) {
      try {
        await walletProvider.request({
          method: "wallet_addEthereumChain",
          params: [maticNetwork],
        });
      } catch (addError) {
        console.error(`Failed to add network:`, addError);
        return {
          status: false,
          message: `Failed to add the network. Please try again.`,
        };
   }
  } else {
    console.error(`Failed to switch network:`, switchError);
        return {
          status: false,
          message: `Failed to switch to the required network. Please try again.`,
        };
  }
}
  }
  return {
    status: true,
    web3
  }
}
  

export const BloackchainGetStakingTokensBalance = async (stakingContractAddress) => {
  try {
    const validate = await validateProvider2(POLYGON_RPC);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);

    let getUsdtAddress = await stakingContract.methods.getUsdtAddress().call();
    let getWbtcAddress = await stakingContract.methods.getWbtcAddress().call();

    let contractErc20GetUsdtAddress = new web3.eth.Contract(Erc20Abi, getUsdtAddress);
    let balanceUSDT = await contractErc20GetUsdtAddress.methods.balanceOf(stakingContractAddress).call();
    let decimalsUSDT = await contractErc20GetUsdtAddress.methods.decimals().call();

    let contractErc20GetWbtcAddress = new web3.eth.Contract(Erc20Abi, getWbtcAddress);
    let balanceWbtc = await contractErc20GetWbtcAddress.methods.balanceOf(stakingContractAddress).call();
    let decimalsWbtc = await contractErc20GetWbtcAddress.methods.decimals().call();
    return {
      status: true,
      usdt: parseInt(balanceUSDT) / 10 ** parseInt(decimalsUSDT),
      wbtc: parseInt(balanceWbtc) / 10 ** parseInt(decimalsWbtc)
    }

  } catch (err) {
    return {
      status: false,
      message: err
    }
  }
}

export const BloackchainGetStakingDetails = async (walletAddress, stakingContractAddress, walletProvider) => {
  try {
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);

    let resStaking = await stakingContract.methods.getStakingDetails(walletAddress.toString()).call();
    let _freeRestakeDeadline = await stakingContract.methods.freeRestakeDeadline().call();
    let getUsdtAddress = await stakingContract.methods.getUsdtAddress().call();
    let getWbtcAddress = await stakingContract.methods.getWbtcAddress().call();

    const formatDate = (timestamp) => {
      const date = new Date(parseInt(timestamp) * 1000);
      return date.toLocaleString('en-GB', {  
        day: '2-digit',  
        month: '2-digit',  
        year: 'numeric',  
        hour: '2-digit',  
        minute: '2-digit',  
        second: '2-digit',  
        hour12: true  
      });
    };


    let mainArr = []
    for (let i = 0; i < resStaking.index.length; i++) {
      if (parseInt(resStaking.amount[i]) > 0) {
        console.log("resReward", parseInt(resStaking.index[i]), walletAddress.toString())
        let resReward = ''
        try {
          resReward = await stakingContract.methods.estimatedRewards(parseInt(resStaking.index[i]), walletAddress.toString()).call();
        } catch (err) {
          resReward = {
            usdtReward: 0,
            wbtcReward: 0,
          }
        }

        mainArr.push({
          amount: parseInt(resStaking.amount[i]) / 10 ** 18,
          index: parseInt(resStaking.index[i]),
          startDate: formatDate(resStaking.startTime[i]),//new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(parseInt(resStaking.startTime[i]) * 1000),
          endDate: formatDate(resStaking.endDate[i]),//new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(parseInt(resStaking.endDate[i]) * 1000),
          endTimeStamp: parseInt(resStaking.endDate[i]),
          todayTimeStamp: Math.floor(Date.now() / 1000),
          restakeEnableTimeStamp: parseInt(resStaking.endDate[i]) - parseInt(_freeRestakeDeadline),
          usdtReward: parseInt(resReward.usdtReward) / 10 ** USDT_DECIMAL,
          //wbtcReward: parseInt(resReward.wbtcReward) / 10 ** 8,
        })
      }
    }
console.log('maaa',mainArr)
    return {
      status: true,
      data: mainArr
    }
  } catch (error) {
    console.error(error);
  }
};


// export const BloackchainGetStakingFees = async (walletAddress, amount, infiDecimal, usdtDecimal, stakingContractAddress, walletProvider) => {
//   try {
//     const validate = await validateProvider(walletProvider);
//     if (!validate.status) {
//       return validate;
//     }
//     let web3 = validate.web3;
//     let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);
//     let stakeAmount = amount * 10 ** parseInt(infiDecimal);
//     stakeAmount = stakeAmount.toLocaleString('fullwide', { useGrouping: false });
//     console.log({ stakeAmount })
//     let checkFee = await stakingContract.methods.getStakingFees(stakeAmount.toString()).call();
//     checkFee = parseInt(checkFee).toLocaleString('fullwide', { useGrouping: false });
//     console.log({ checkFee })
//     let finalFee = parseInt(checkFee) / 10 ** parseInt(usdtDecimal);
//     finalFee = finalFee.toLocaleString('fullwide', { useGrouping: false });
//     console.log({ finalFee })
//     return {
//       status: true,
//       fee: finalFee
//     }
//   } catch (error) {
//     return {
//       status: false,
//       message: "Something went wrong. Please try agian." // error.toString()
//     }
//   }
// };

export const BloackchainGetStakingMinMaxAmount = async (amount, infiDecimal, stakingContractAddress, walletProvider) => {
  try {
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;

    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);
    let stakeAmount = parseFloat(amount * 10 ** parseInt(infiDecimal));
    stakeAmount = stakeAmount.toLocaleString('fullwide', { useGrouping: false });
    let checkMinAndMaxStake = await stakingContract.methods.getMinAndMaxStakeAmount(stakeAmount).call();
    let minStake = parseInt(checkMinAndMaxStake.minStake);
    minStake = minStake.toLocaleString('fullwide', { useGrouping: false });
    let maxStake = parseInt(checkMinAndMaxStake.maxStake);
    maxStake = maxStake.toLocaleString('fullwide', { useGrouping: false });

    if (parseInt(stakeAmount) < parseInt(minStake)) {
      let minAmt = minStake / 10 ** parseInt(infiDecimal);
      return {
        status: true,
        message: "Minimum stake amount should be >= " + minAmt + ' INFI'
      }
    }
    else if (parseInt(stakeAmount) > parseInt(maxStake)) {
      let maxAmt = maxStake / 10 ** parseInt(infiDecimal);
      return {
        status: true,
        message: "Maximum stake amount should be <= " + maxAmt + ' INFI'
      }
    }
    else {
      return {
        status: true,
        message: ""
      }
    }
  } catch (error) {
    return {
      status: false,
      message: "Something went wrong. Please try agian." // error.toString()
    }
  }
};

export const BloackchainStakeToken = async (req) => {
  try {
    const { walletProvider, walletAddress, amount, infiDecimal, stakingContractAddress } = req;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);
    let tokenAmount = amount * 10 ** parseInt(infiDecimal);
    tokenAmount = tokenAmount.toLocaleString('fullwide', { useGrouping: false });

    let _getTotalUserStaking = await stakingContract.methods.getTotalUserStaking(walletAddress).call();
    console.log('123', _getTotalUserStaking);
    let totalUserStaking = parseFloat(web3.utils.fromWei(_getTotalUserStaking, 'ether'));
    let newTotal = totalUserStaking + Number(amount);
    //console.log('789', newTotal, amount);
    //console.log('xxx', newTotal > 12000);
    if (newTotal > 12000) {
      let remaining = 12000 - totalUserStaking;
      return {
        message: `Total INFI staking exceeded. You have a limit of ${remaining} INFI left to stake.`
      };
    }

    let trx = await stakingContract.methods.stake(tokenAmount);
    let encodeData = trx.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();
    
    console.log({
      function: "BloackchainStakeToken",
      stakeAmount: tokenAmount,
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
    });

    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });

    console.log('Transacting...');

    const txData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });

    return {
      status: true,
      hash: txData.transactionHash
    };

  } catch (error) {
    console.log('staking error', error);
    return {
      status: false,
      message: error?.data?.message?.toString() || error.message
    };
  }
};


export const BloackchainGetEstimatedAmountAfterUnstake = async (req) => {
  try {
    const { walletProvider, amount, infiDecimal, usdtDecimal, stakingContractAddress } = req;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);
    let tokenAmount = amount * 10 ** parseInt(infiDecimal);
    tokenAmount = tokenAmount.toLocaleString('fullwide', { useGrouping: false });

    let estimatedInfo = await stakingContract.methods.getEstimatedAmountAfterUnstakeAndSell(tokenAmount).call();
    console.log({ estimatedInfo })
    let finalAmount = parseInt(estimatedInfo.finalAmount);
    let penalty = parseInt(estimatedInfo.penalty);
    finalAmount = finalAmount.toLocaleString('fullwide', { useGrouping: false });
    finalAmount = finalAmount / 10 ** parseInt(infiDecimal);
    penalty = penalty / 10 ** parseInt(infiDecimal);

    console.log({
      function: 'BloackchainGetEstimatedAmountAfterUnstake',
      amount,
      tokenAmount,
      chainId,
      estimatedInfo,
      finalAmount,
      penalty
    })
    return {
      status: true,
      finalAmount,
      penalty
    }
  }
  catch (error) {
    return {
      status: false,
      message: "Something went wrong. Please try agian." // error.toString()
    }
  }
}

export const BloackchainUnStakeAndSellToken = async (req) => {
  try {
    const { walletProvider, walletAddress, amount, stakingIndex, stakingContractAddress, infiDecimal } = req;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);
    let tokenAmount = amount * 10 ** parseInt(infiDecimal);
    tokenAmount = tokenAmount.toLocaleString('fullwide', { useGrouping: false });

    let trx = await stakingContract.methods.unstakeAndSell(stakingIndex.toString(), tokenAmount.toString());

    let encodeData = trx.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();
    console.log({
      function: 'BloackchainUnStakeAndSellToken',
      amount,
      tokenAmount,
      stakingIndex,
      stakingContractAddress,
      walletAddress
    })

    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    console.log('Transacting...')

    const txData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });

    return {
      status: true,
      hash: txData.transactionHash
    }
  } catch (error) {
    return {
      status: false,
      message: "Something went wrong. Please try agian." // error.toString()
    }
  }
};

export const BloackchainRewardClaimNow = async (req) => {
  try {
    const { walletProvider, walletAddress, stakingIndex, stakingContractAddress } = req;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);

    let trx = await stakingContract.methods.claimRewards(stakingIndex);
    let encodeData = trx.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();

    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    console.log('Transacting...')

    const txData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    return {
      status: true,
      hash: txData.transactionHash
    }

  } catch (error) {
    return {
      status: false,
      message: "Something went wrong. Please try agian." // error.toString()
    }
  }
}

export const BloackchainUnStakeNow = async (req) => {
  try {
    const { walletProvider, walletAddress, stakingIndex, stakingContractAddress, amount, infiDecimal } = req;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);
    let tokenAmount = amount * 10 ** parseInt(infiDecimal);
    tokenAmount = tokenAmount.toLocaleString('fullwide', { useGrouping: false });
    console.log({
      tokenAmount,
      stakingIndex
    })
    let trx = await stakingContract.methods.unstake(stakingIndex);
    let encodeData = trx.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();

    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    console.log('Transacting...')

    const txData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    return {
      status: true,
      hash: txData.transactionHash
    }

  } catch (error) {
    return {
      status: false,
      message: "Something went wrong. Please try agian." // error.toString()
    }
  }
}

export const BloackchainReStakeNow = async (req) => {
  try {
    const { walletProvider, walletAddress, stakingIndex, stakingContractAddress } = req;
    const validate = await validateProvider(walletProvider);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let chainId = web3Config.CHAIN;

    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);

    let trx = await stakingContract.methods.restake(stakingIndex);
    let encodeData = trx.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();

    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    console.log('Transacting...')

    const txData = await web3.eth.sendTransaction({
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      to: stakingContractAddress,
      from: walletAddress,
      data: encodeData,
      chainId: chainId,
    });
    return {
      status: true,
      hash: txData.transactionHash
    }
  } catch (error) {
    return {
      status: false,
      message: "Something went wrong. Please try agian." // error.toString()
    }
  }
}

export const BloackchainGetTotalContractStaking = async (stakingContractAddress) => {
  try {
    const validate = await validateProvider2(POLYGON_RPC);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let stakingContract = new web3.eth.Contract(StakingAbi, stakingContractAddress);

    let getStaking = await stakingContract.methods.getTotalInfiStaking().call();
    return {
      status: true,
      total: Number(getStaking)/10**18
    }

  } catch (err) {
    return {
      status: false,
      message: err
    }
  }
}

const validateProvider2 = async (walletProvider) => {
  console.log("validateProvider2");
  try {
    if (!walletProvider) {
      console.log("walletProvider");

      return {
        status: false,
        message: `Please connect your web3 wallet`,
      };
    }
    const web3 = new Web3(walletProvider);

    return {
      status: true,
      web3
    };
  } catch (error) {
    console.log("Error in validateProvider :", error);
    return {
      status: false,
      message: "Error in validating provider. Please try again.",
    };
  }
};
